import qs from "qs";
import { currentCompany } from "./utils";
import "reflect-metadata";
import store from "@/stores";
import { processImageSources } from "./image";
import { AuthApi } from "@/services/api/auth";
import { plainToClassFromExist } from "class-transformer";
import { ResponseModel } from "@/models/classes/response";
import { SaleOrgModel } from "@/models/classes/user";
import { alert } from '@/components/modals/alert';
import axios from "axios";
const SALE_ORG_CODE = "CVM00000001";
// const SALE_ORG_CODE_DEMO_007 = 'SSC00000001';

const CVM_MAP_USER = {
  "11027427": "CVM00000002",
  "11027428": "CVM00000001",
  "11023061": "CVM00000003",
  "11027744": "CVM00000004",
  "11015953": "CVM00000005",
  "70002780": "CVM00000006",
  "11027651": "CVM00000007",
  "11004782": "CVM00000008",
  "70125888": "CVM00000009",
  "70004967": "CVM00000010",
  "70081960": "CVM00000011",
  "70121116": "CVM00000012",
  "11035050": "CVM00000013",
  "11011308": "CVM00000014",
  "70073753": "CVM00000015",
  "11027673": "CVM00000016",
  "11013034": "CVM00000017",
  "11027743": "CVM00000018",
  "70014592": "CVM00000019",
  "70080240": "CVM00000020",
  "70101067": "CVM00000021",
  "11029066": "CVM00000022",
  "10300269": "CVM00000003",
  "91005708": "CVM00000003",
  "10300656": "CVM00000003",
  "11030173": "CVM00000003",
  "70081499": "CVM00000019",
  "91008561": "CVM00000019",
  "10300169": "CVM00000019",
  "70027970": "CVM00000022",
  "91006020": "CVM00000022",
  "10300653": "CVM00000022",
  DEMO0001: "SSC00000001",
  DEMO0003: "SSC00000001",
  DEMO0004: "SSC00000001",
  DEMO0006: "SSC00000001",
  DEMO0007: "SSC00000001",
  DEMO0013: "SSC00000001",
  DEMO0012: "MCMC0000001",
  DEMO0015: "SSC00000001",
  DEMO0018: "MCMC0000001",
  DEMO0019: "SSC00000001",
  DEMO0020: "MCMC0000001",
  DEMO0021: "MCMC0000001",
  DEMO0027: "MCMC0000001",
  "50194365": "SSC00000001",
  "70038715": "SSC00000001",
  "70033523": "SSC00000001",
  "70063615": "SSC00000001",
  "70066709": "SSC00000001",
  "70065043": "SSC00000001",
};

const NSI_DOMAIN = process.env.REACT_APP_NEWSALE_DOMAIN;
const NSI_SERVICE_API = process.env.REACT_APP_NEWSALE_SERVICE_API;
const BEER_APP_DOMAIN = process.env.REACT_APP_BEER_APP_DOMAIN!;
const BEER_APP_LOCAL = 'http://localhost:3000'
const GO_TO_PUBLISH_TAKEORDER = NSI_DOMAIN + "/mobile/foc/product-list";
const PAYIN_SLIP_DOMAIN = process.env.REACT_APP_PAYIN_SLIP!;
const ISP_DOMAIN = process.env.REACT_APP_ISP_DOMAIN!;
// const API_URL = process.env.REACT_APP_API_URL;
const api = new AuthApi();

/**
 * Extract param from ?param when param is either infornt or behide #
 * @param param param name to extract
 * @returns param value as string
 */
export const getParam = (param: string) => {
  const queryParams = qs.parse(window.location.hash.split("?")[1], {
    ignoreQueryPrefix: true,
  });
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get(param);

  let storedAccessToken = localStorage.getItem(param);
  if (typeof token === "string") {
    return token;
  } else if (typeof queryParams?.[param] === "string") {
    return queryParams[param] as string;
  } else {
    return false;
  }
};

// /**
//  * generate callback to program
//  * @param path string path in url afer # ex. '/VisitNoPlane/detail'
//  * @param queryString string query params after ? ex. 'param1=1&param2=2'
//  * @returns
//  */
// export const generateCallBackURL = (path: string, queryString: string = '') => {
//   // if (window.location.origin === 'file://') {
//   let param = queryString === '' ? '?ShowPopUp=false' : '?ShowPopUp=false&' + queryString;
//   return encodeURIComponent(window.location.origin + '/#' + path + param);
// };

/**
 * generate callback to program
 * @param path string path in url afer # ex. '/VisitNoPlane/detail'
 * @param queryString string query params after ? ex. 'param1=1&param2=2'
 * @returns
 */
export const generateTechServCallBackURL = (path: string, queryString: string = "") => {
  // if (window.location.origin === 'file://') {
  if (window?.androidWebview) {
    //redirect for techserv intend
    let param = "&queryString=" + encodeURIComponent(queryString + "&timestamp=" + Date.now() + "&ShowPopUp=false");

    localStorage.setItem("lastpath", path);
    localStorage.setItem("lastparam", decodeURIComponent(param));
    return encodeURIComponent(`techserv://subapp?appId=${process.env.REACT_APP_APP_ID}&subPath=${encodeURIComponent("#" + path)}` + param);
  } else {
    let param = queryString === "" ? "?ShowPopUp=false" : "?ShowPopUp=false&" + queryString;
    return encodeURIComponent(window.location.origin + "/#" + path + param);
  }
};
interface ExtenalParam {
  // teamcode?: string
}

export async function getVehicleProduct() {
  const userData = JSON.parse(localStorage.getItem("user") ?? "{}")?.profile;
  const salesOrgCode = JSON.parse(localStorage.getItem("saleOrgData") ?? "{}")?.selectedSaleOrgCriteriaCode;
  const contactId = userData?.contactId;
  const saleDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0];
  // if (!userData) return [];
  // console.log("NSI_SERVICE_API:", NSI_SERVICE_API);//CheckCustomerProduct
  // if (NSI_SERVICE_API === undefined) return undefined;
  try {
    // const resp = await axios.get(`${NSI_SERVICE_API}/nsi-retail-service/v1/vehicle-stocks/products?salesOrgCode=${salesOrgCode}&contactId=${contactId}&saleDate=${saleDate}`);
    const resp = await axios.get(`/api/Customer/CheckCustomerProduct?salesOrgCode=${salesOrgCode}&contactId=${contactId}&saleDate=${saleDate}`);
    return resp.data.data;
  } catch (error) {
    console.error("Error fetching vehicle products:", error);
    return undefined;
  }
}

async function redirectExternal(baseUrl: string, flag: string = "", data: any = undefined) {
  if (baseUrl == "") return false;
  const orgData = store.getState().authorization.auth.saleOrg;
  const teamcode = orgData?.selectedSaleOrgCriteriaCode;
  const companyCode = orgData?.selectedSaleOrgCompanyCode;

  // // !HARD CODE saleorg code for DEMO0007
  // const curEmployeeID = JSON.parse(localStorage.getItem("user") ?? "{}")?.profile?.employeeId;
  // //@ts-ignore
  // const salesOrgCode = CVM_MAP_USER[curEmployeeID] !== undefined ? CVM_MAP_USER[curEmployeeID] : SALE_ORG_CODE;


  const token = localStorage.getItem("accessToken");
  const location = localStorage.getItem("location") ?? "";


  // let param = `salesTeamCode=${teamcode}&companyCode=${companyCode}&callback=${generateTechServCallBackURL('')}&token=${token}`;
  // let param = `salesOrgCode=${SALE_ORG_CODE}&callback=${generateTechServCallBackURL('')}&token=${token}`;
  const saleOrgData = JSON.parse(localStorage.getItem("saleOrgData") ?? "{}");
  let salesOrgCode = saleOrgData?.selectedSaleOrgCriteriaCode;
  let saleOrgCriteriaName = saleOrgData?.selectedSaleOrgCriteriaName;
  let saleOrgCriteriaId = saleOrgData?.selectedSaleOrgCriteriaId;
  //Force to get saleorg data if not found in localstorage
  let selectedSaleOrgCenterCode = saleOrgData?.selectedSaleOrgCenterCode;
  if (salesOrgCode == undefined || salesOrgCode == "") {
    console.log("%c No salesOrgCode found please select sales org first", "color:red; font-style:bold");
    try {
      const resOrgData = await api.getCurrentSaleOrg();
      const resOrgModel = plainToClassFromExist(new ResponseModel<SaleOrgModel>(SaleOrgModel), resOrgData);
      if (resOrgModel.status == 200 && typeof resOrgModel.data == "object") {
        localStorage.setItem("saleOrgData", JSON.stringify(resOrgModel.data));
        salesOrgCode = resOrgModel.data.selectedSaleOrgCriteriaCode;
        saleOrgCriteriaName = resOrgModel.data.selectedSaleOrgCriteriaName;
        saleOrgCriteriaId = resOrgModel.data.selectedSaleOrgCriteriaId;
      }
      else {
        throw new Error("Cannot fetch saleorg data");
      }
    } catch (error) {
      alert.error("ไม่สามารถดึงข้อมูลสาขาขายได้ กรุณาเลือก Organize ใหม่อีกครั้ง");
      return;
    }

  };
  const callback = decodeURIComponent(generateTechServCallBackURL(""));
  let param: any = {
    salesOrgCode: salesOrgCode,
    companyCode: companyCode,
    // salesTeamCode: teamcode,
    callback,
    token: token,
    salesMethod: "",
    saleOrgCriteriaId,
    saleOrgCriteriaName,
  };

  if (location !== "") {
    const locObj = JSON.parse(location);
    param.latitude = locObj.lat;
    param.longitude = locObj.lon;
  }

  if (flag === "report") {
    param = {
      salesOrgCode: salesOrgCode,
      companyCode: companyCode,
      // salesTeamCode: teamcode,
      callback,
      token: token,
      salesMethod: data?.salesMethod || "",
      saleOrgCriteriaId,
      saleOrgCriteriaName,
    };
  } else if (flag === "takeorder") {
    //This is take order if there is extra data
    // param = `salesTeamCode=${teamcode}&companyCode=${companyCode}&customerId=${data.customerId}&customerCode=${data.customerCode}&paymentType=${data.type}&callback=${data.callback}&token=${token}`;
    param = {
      salesOrgCode: salesOrgCode,
      // salesTeamCode: teamcode,
      companyCode: companyCode,
      customerId: data.customerId,
      customerUUid: data.customerUUid,
      customerCode: data.customerCode,
      // paymentType: data.type,
      callback: decodeURIComponent(data.callback),
      token: token,
      salesMethod: data.SalesMethod ?? "",
      salesType: data.SalesType ?? "",
      saleOrgCriteriaId,
      saleOrgCriteriaName,
    };
  } else if (flag === "goodHistory") {
    // param = `salesOrderDate=${data?.salesOrderDate}&salesTeamCode=${teamcode}&companyCode=${companyCode}&callback=${generateTechServCallBackURL('')}&token=${token}`;
    // const isDirectSale = !!menuTakeOrder.data?.find((x) => (x.menuHandler == "directSales"))//directsale
    param = {
      salesOrgCode: salesOrgCode,
      salesOrderDate: data?.salesOrderDate,
      // salesTeamCode: teamcode,
      companyCode: companyCode,
      callback,
      token: token,
      salesMethod: data?.salesMethod || "",
      saleOrgCriteriaId,
      saleOrgCriteriaName,
    };
  } else if (flag === "campaign") {
    //foc/product-list?salesOrgCode=CVM00000001&customerCode=200497030&salesType=foc&campaignId=[campaignId]&surveyId=[surveyId]callback=https:%2F%2Fsit.imaginic.dev%2F%23%2Fvisitnoplan%2Fvisit%2F503857%3FShowPopUp%3Dfalse&token=[token]
    param = {
      salesOrgCode: salesOrgCode,
      customerId: data.customerId,
      customerUUid: data.customerUUid,
      customerCode: data.customerCode,
      salesType: "foc",
      campaignId: data.campaignId,
      surveyId: data.surveyId,
      callback: decodeURIComponent(data.callback),
      token: token,
      salesMethod: data.salesMethod || "directSales",
      saleOrgCriteriaId,
      saleOrgCriteriaName,
    };
  } else if (flag === "productPrice") {
    param = {
      salesOrgCode: salesOrgCode,
      callback,
      token: token,
      saleOrgCriteriaId,
      saleOrgCriteriaName,
    };
  } else if (flag === "salesHistory") {
    baseUrl += '/' + data.customerCode;
    param = {
      companyCode: companyCode,
      salesOrgCode: salesOrgCode,
      customerCode: data.customerCode,
      customerId: data.customerId,
      customerUUid: data.customerUUid,
      callback: decodeURIComponent(data.callback),
      token: token,
      saleOrgCriteriaId,
      saleOrgCriteriaName,
    };
  }
  else if (flag === "beerApp") {
    param = {
      callback,
      provider: "sales_teams",
      source: "sales_teams",
      token: token,
    };
  } else if (flag === "payinSlip") {
    param = {
      callback,
      token: token,
    };

  } else if (flag === "deposite") {
    param = {
      salesOrgCode: salesOrgCode,
      companyCode: companyCode,
      customerId: data.customerId,
      customerUUid: data.customerUUid,
      customerCode: data.customerCode,
      callback: decodeURIComponent(data.callback),
      token: token,
      salesMethod: "directSales",
      salesType: "returnable",
      saleOrgCriteriaId,
      saleOrgCriteriaName,
    };
  } else if (flag === "returnProduct") {
    param = {
      salesOrgCode: salesOrgCode,
      companyCode: companyCode,
      customerId: data.customerId,
      customerUUid: data.customerUUid,
      customerCode: data.customerCode,
      callback: decodeURIComponent(data.callback),
      token: token,
      salesMethod: data.salesMethod || "", //"directSales"
      salesType: "returnable",
      saleOrgCriteriaId,
      saleOrgCriteriaName,
    };
  } else if (flag === "goodsReservation" || flag === "vanApp" || flag === "returnGood") {
    param.salesMethod = "directSales";

  } else if (flag === "goldenPicture") {
    param = {
      salesOrgCode: salesOrgCode,
      companyCode: companyCode,
      customerId: data.customerId,
      customerUUid: data.customerUUid,
      customerCode: data.customerCode,
      callback: decodeURIComponent(data.callback),
      token: token,
      salesMethod: data.salesMethod || "", //"directSales"
      salesType: "returnable",
      saleOrgCriteriaId,
      saleOrgCriteriaName,
    };

    param = {
      center: selectedSaleOrgCenterCode,
      customerId: data.customerId,
      customerUUid: data.customerUUid,
      "eactivityId": "",
      "saleIntSurveyId": "",
      saleOrgCriteriaId,
      saleOrgCriteriaName,
      shopCode: data.customerCode,
      surveyDocId: "AA0001",
      surveyId: "survey_golden_picture",
      callback: decodeURIComponent(data.callback),
      token: token,
    }

  } else if (flag === "payment") {
    // ?customerCode={customerCode}&callback={callback}&token={token}
    // customerCode={customerCode}&salesOrgCode={salesOrgCode}&compayCode={compayCode}&callback={callback}&token={token}
    param = {
      salesOrgCode: salesOrgCode,
      customerCode: data.customerCode,
      customerId: data.customerId,
      customerUUid: data.customerUUid,
      companyCode: companyCode,
      callback: decodeURIComponent(data.callback),
      token: token,
      saleOrgCriteriaId,
      saleOrgCriteriaName,
    };
  }
  const search = new URLSearchParams(param).toString();
  const link = baseUrl + "?" + search;
  console.log(link);
  window.open(link, "_self");
}
//@ts-ignore
window.redirectExternal = redirectExternal;
/**
 * Redirect to external "เบิกสินค้า"
 */
export const goToGoodsReservationApp = () => {
  // const teamcode = data?.teamcode ?? '12027'
  const baseUrl = process.env.REACT_APP_WITHDRAW_URL!;
  redirectExternal(baseUrl, "goodsReservation");
};

/**
 * Redirect to external "สินค้าบนรถ"
 */
export const goToVanApp = () => {
  // const teamcode = data?.teamcode ?? '12027'
  const baseUrl = NSI_DOMAIN + "/mobile/goods-reservation/vehicle-stocks";
  redirectExternal(baseUrl, "vanApp");
};

/**
 * Redirect to good history 
 * @param salesOrderDate string date std format "2024-01-01"
 */
export const goToGoodsHistory = (data: { salesOrderDate: string, salesMethod?: string }) => {
  const baseUrl = process.env.REACT_APP_GOODS_HISTORY_URL!;
  redirectExternal(baseUrl, "goodHistory", data);
};

export const goToReport = (data?: { salesMethod?: string }) => {
  console.log(data);
  const baseUrl = process.env.REACT_APP_GOODS_REPORT_URL!;
  redirectExternal(baseUrl, "report", { report: true, ...data });
};

export const goToCampaign = (data: { customerCode: string, customerId: number, customerUUid: string, campaignId: string | number, surveyId: string | null, callback: string, salesMethod?: string }) => {
  //require customerCode, campaignId, surveyId, callback
  const baseUrl = GO_TO_PUBLISH_TAKEORDER;
  redirectExternal(baseUrl, "campaign", data);
};

export const goToProductPrice = () => {
  const baseUrl = NSI_DOMAIN + "/mobile/products/prices";
  redirectExternal(baseUrl, "productPrice");
}

export const goToSalesHistory = (data: { customerCode: string, customerUUid: string, customerId: number, callback: string }) => {
  //require customerCode, callback
  const baseUrl = NSI_DOMAIN + "/mobile/report/customers";
  redirectExternal(baseUrl, "salesHistory", data);
}

//คืนสินค้า
export const goToReturnGood = () => {
  const baseUrl = NSI_DOMAIN + "/mobile/goods-return/vehicle-stocks";
  redirectExternal(baseUrl, "returnGood");
}
// ?salesOrderDate=2024-11-17&salesTeamCode=12027&companyCode=4900&&callback=https:%2F%2Fsit.imaginic.dev%2F%23%2Fvisitnoplan%2Fvisit%2F503218%3FShowPopUp%3Dfalse&token=

export const goToGoldenPicture = (data: { customerCode: string, customerId: number, customerUUid: string, callback: string }) => {
  const baseUrl = ISP_DOMAIN;
  console.log("goToGoldenPicture", baseUrl, data);
  redirectExternal(baseUrl, "goldenPicture", data);
}

export const goTobeerApp = () => {
  const baseUrl = BEER_APP_DOMAIN;
  redirectExternal(baseUrl, "beerApp");
}
export const goTobeerAppLocal = () => {
  const baseUrl = BEER_APP_LOCAL;
  redirectExternal(baseUrl, "beerApp");
}

export const goToPayment = (data: { customerCode: string, customerId: number, customerUUid: string, callback: string }) => {
  // https://nsi-dev.thaibevapp.com/mobile/sales-order/debt-repayment?customerNo={customerNo}&salesOrgCode={salesOrgCode}&callback={callback}&token={token}
  // https://nsi-dev.thaibevapp.com/mobile/sales-order/debt-repayment?customerCode={customerCode}&salesOrgCode={salesOrgCode}&compayCode={compayCode}&callback={callback}&token={token}
  const baseUrl = NSI_DOMAIN + '/mobile/sales-order/debt-repayment';
  redirectExternal(baseUrl, "payment", data);
}
export const goToPayinSlip = () => {
  const baseUrl = PAYIN_SLIP_DOMAIN;
  redirectExternal(baseUrl, "payinSlip");
}

export const goToDeposite = (data: { customerId: number, customerUUid: string, customerCode: string, callback: string, salesMethod: string }) => {
  //https://nsi-dev.thaibevapp.com/mobile/sales-order/returnable-deposit?salesOrgCode={salesOrgCode}&companyCode={companyCode}&customerId={customerId}&customerUUid={customerUUid}d&customerCode={customerCode}&callback=https:%2F%2Fsit.imaginic.dev%2F%23%2Fvisitnoplan%2Fvisit%2F503857%3FShowPopUp%3Dfalse&token={token}&salesMethod={salesMethod}&salesType=returnable&saleOrgCriteriaId={saleOrgCriteriaId}&saleOrgCriteriaName={saleOrgCriteriaName}
  const baseUrl = NSI_DOMAIN + '/mobile/sales-order/returnable-deposit';
  redirectExternal(baseUrl, "deposite", data);
}
export const goToReturnProduct = (data: { customerId: number, customerUUid: string, customerCode: string, callback: string, salesMethod: string }) => {
  // https://nsi-dev.thaibevapp.com/mobile/return-pickup/product-list?salesOrgCode={salesOrgCode}&companyCode={companyCode}&customerId={customerId}&customerUUid={customerUUid}d&customerCode={customerCode}&callback=https:%2F%2Fsit.imaginic.dev%2F%23%2Fvisitnoplan%2Fvisit%2F503857%3FShowPopUp%3Dfalse&token={token}&salesMethod={salesMethod}&salesType={salesType}&saleOrgCriteriaId={saleOrgCriteriaId}&saleOrgCriteriaName={saleOrgCriteriaName}
  const baseUrl = NSI_DOMAIN + '/mobile/return-pickup/product-list';
  redirectExternal(baseUrl, "returnProduct", data);
}

interface takeorder_param extends ExtenalParam {
  type: string;
  customerCode: string;
  customerId: string;
  customerUUid: string;
  callback: string;
  SalesMethod?: string;
  SalesType?: string;
}
export const takeorder = (data: takeorder_param) => {
  // const teamcode = data?.teamcode ?? '12027'
  let baseUrl = NSI_DOMAIN + "/mobile/sales-order/take-order";
  // const type = data.type;
  // if (type == 'cash') {
  //   baseUrl = process.env.REACT_APP_TAKE_ORDER_CASH_URL!;
  // } else if (type == 'credit') {
  //   baseUrl = '';
  // }
  redirectExternal(baseUrl, "takeorder", data);
  // if (baseUrl == '') return false;

  // const token = localStorage.getItem('accessToken');
  // const param = `salesTeamCode=${teamcode}&companyCode=${currentCompany().code}&customerId=${data.customerId}&paymentType=${type}&callback=${data.callback}&token=${token}`;
  //let url = `vsms_android://com.thaibev.vsms/Customer?EmployeeId=${payload.employeeId}&CustomerCode=${payload.customerCode}&CallBackURL=${encodeURIComponent(callBack)}`;
  // const link = baseUrl + '?' + param;
  // window.open(link, '_self');
};

interface vsms_param extends ExtenalParam {
  customerCode: string;
  customerId: number | string;
  customerUUid: string;
  employeeId: string;
  callback: string;
}
export const vsmsCompanyList = () => ["7800", "5700"]; // default ["7800", "5700"]
export const toVSMS = (data: vsms_param) => {
  // vsms_android://com.thaibev.vsms/Customer?EmployeeId=91005730&CustomerCode=1314676&CallBackURL=techserv%3A%2F%2Fsubapp%3FappId%3D2%26subPath%3D%2523%252FVisitNoPlan%252FDetail%252F14888
  let link = `vsms_android://com.thaibev.vsms/Customer?EmployeeId=${data.employeeId}&CustomerCode=${data.customerCode}&CustomerId=${data.customerId}&CustomerUUid=${data.customerUUid}&CallBackURL=${data.callback}`;
  if (!window?.androidWebview) {
    return console.log("%c Protocal not support please open on techserv", "color:red; font-style:bold");
  }
  window.androidWebview.navigate(link, {
    shouldRedirect: true,
  });
};
